import React, { useEffect } from 'react';
import { Slide } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { TransitionProps } from '@mui/material/transitions';

import { TradingContextProvider } from '@trader/contexts';
import { MODAL_TYPES } from '@trader/constants';
import { useMst } from '@trader/store';
import {
  AddFunds,
  AddProtection,
  AccountStatement,
  CancelOrder,
  ClosePosition,
  CreateAlert,
  CreateOrder,
  DeleteAlert,
  EditOrder,
  MyHistory,
  Settings,
  Statistics,
  ResultChallenge,
  OrderResponse,
} from '@trader/modals';

import * as Styled from './styled';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>
) {
  return (
    <Slide direction='right' ref={ref} {...props}>
      {props.children}
    </Slide>
  );
});

const withContext = (component: React.ReactNode) => (
  <TradingContextProvider>{component}</TradingContextProvider>
);

export const Modals: React.FC = observer(() => {
  const store = useMst();
  const modal = store.ui.modal;

  const shouldHideCloseButton = modal.options.get('shouldHideCloseButton');

  const isDisablePadding = modal.id === MODAL_TYPES.myHistory;

  useEffect(() => {
    if (
      modal.isOpen &&
      (modal.id === MODAL_TYPES.placeOrder ||
        modal.id === MODAL_TYPES.addProtection ||
        modal.id === MODAL_TYPES.closePosition ||
        modal.id === MODAL_TYPES.cancelOrder ||
        modal.id === MODAL_TYPES.editOrder)
    ) {
      (!store.user.profile.isRegistrationCompleted ||
        !store.user.profile.isTradingAllowed) &&
        store.user.getProfileDemoAsync.run();
    }

    if (modal.isOpen && modal.id === MODAL_TYPES.addFunds) {
      !store.user.profile.isDepositAllowed &&
        store.user.getProfileDemoAsync.run();
    }
  }, [modal.isOpen, store.user.profile]);

  return (
    <Styled.Modal
      $isDisablePadding={isDisablePadding}
      isOpen={modal.isOpen}
      shouldHideCloseButton={shouldHideCloseButton}
      TransitionComponent={Transition}
    >
      {modal.id === MODAL_TYPES.placeOrder && withContext(<CreateOrder />)}
      {modal.id === MODAL_TYPES.addProtection && withContext(<AddProtection />)}
      {modal.id === MODAL_TYPES.closePosition && withContext(<ClosePosition />)}
      {modal.id === MODAL_TYPES.cancelOrder && withContext(<CancelOrder />)}
      {modal.id === MODAL_TYPES.editOrder && withContext(<EditOrder />)}
      {modal.id === MODAL_TYPES.createPriceAlert &&
        withContext(<CreateAlert />)}
      {modal.id === MODAL_TYPES.addFunds && <AddFunds />}
      {modal.id === MODAL_TYPES.accountStatement && <AccountStatement />}
      {modal.id === MODAL_TYPES.deleteAlert && <DeleteAlert />}
      {modal.id === MODAL_TYPES.settings && <Settings />}
      {modal.id === MODAL_TYPES.statistics && <Statistics />}
      {modal.id === MODAL_TYPES.myHistory && <MyHistory />}
      {modal.id === MODAL_TYPES.resultChallenge && <ResultChallenge />}
      {modal.id === MODAL_TYPES.orderResponse && <OrderResponse />}
    </Styled.Modal>
  );
});
